import { useEffect } from "react";
import { AdminCardStyles } from "./AdminCard.style";
import { Table } from "../../atoms";
import { structureData } from "../../../utils/FormatData";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { getLinkedAzureGroups } from "../../../Redux/Zte/Ztna/ZtnaActions";
import SearchFilter from "../SearchFilter/SearchFilter";

const ServiceGroupsTable = () => {
  const headers = ["Service", "Groups"];
  const [ztnaServiceName, setZtnaServiceName] = useState("");
  const [serviceIdentifierName, setServiceIdentifierName] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLinkedAzureGroups(ztnaServiceName, serviceIdentifierName));
  }, [dispatch, ztnaServiceName, serviceIdentifierName]);

  const { linkedAzureAdGroups, fetchingLinkedAzureAdGroups } = useSelector(
    (state) => state.ztna
  );

  const formatData = (data) => {
    let result = [];
    for (let i in data) {
      let groups = [];
      for (let j in data[i]) {
        groups.push(` ${data[i][j]}`);
      }
      result.push({ service: i, groups: `${groups}` });
    }
    return result;
  };
  return (
    <AdminCardStyles>
      <div className="ztna-container">
        <SearchFilter
          setSearchQuery={setZtnaServiceName}
          placeholder="Service"
        />
        <SearchFilter
          setSearchQuery={setServiceIdentifierName}
          placeholder="Identifier"
        />
      </div>
      <div className="table-style">
        <Table
          headers={headers}
          data={structureData(
            "aadGroupAssignments",
            formatData(linkedAzureAdGroups)
          )}
          loading={fetchingLinkedAzureAdGroups}
        />
      </div>
    </AdminCardStyles>
  );
};

export default ServiceGroupsTable;
